import Blog from '../views/Blog/Index';
import Post from '../views/Blog/SinglePage';
import Teams from '../views/Teams/Index';
import Students from '../views/Students/Index';
import DoneHomework from '../views/Students/DoneHomework';
import DoneQuizzes from '../views/Students/DoneQuizzes';
import RateQuiz from '../views/Students/RateQuiz';
import Subjects from '../views/Subjects/Index';
import Lessons from '../views/Lessons/Index';
import Homework from '../views/Homework/Index';
import Profile from '../views/User/Profile';
import Quizzes from '../views/Quizzes/Index';
import QuizStart from '../views/Quizzes/Start'
import Results from '../views/Results/Index';
import Help from '../views/Help/Index';

const routes = [
    {path: 'blog',      name: 'Blog',      component: Blog,        meta    : { layout : 'home',  requiresAuth : true, title : 'Blog' }},
    {path: 'blog',      name: 'Post',      component: Post,        meta    : { layout : 'home',  requiresAuth : true, title : 'Blog' }},
    {path: 'teams',     name: 'Teams',     component: Teams,       meta    : { layout : 'home',  requiresAuth : true, title : 'Teams'}},
    {path: 'students',  name: 'Students',  component: Students,    meta    : { layout : 'home',  requiresAuth : true, title : 'Students'}},
    {path: 'students/done/homework', name: 'DoneHomework', component: DoneHomework, meta: { layout: 'home', requiresAuth: true, title : 'Homework'}},
    {path: 'students/done/quizzes', name: 'DoneQuizzes', component: DoneQuizzes, meta: { layout: 'home', requiresAuth: true, title : 'Quizzes'}},
    {path: 'students/rate/quiz', name: 'RateQuiz', component: RateQuiz, meta: { layout: 'home', requiresAuth: true, title : 'Rate Quiz'}},
    {path: 'subjects',  name: 'Subjects',  component: Subjects,    meta    : { layout : 'home',  requiresAuth : true, title : 'Subjects'}},
    {path: 'lessons',   name: 'Lessons',   component: Lessons,     meta    : { layout : 'home',  requiresAuth : true, title : 'Lessons'}},
    {path: 'homework',  name: 'Homework',  component: Homework,    meta    : { layout : 'home',  requiresAuth : true, title : 'Homework'}},
    {path: 'profile',   name: 'Profile',   component: Profile,     meta    : { layout : 'home',  requiresAuth : true, title : 'Profile'}},
    {path: 'quizzes',   name: 'Quizzes',   component: Quizzes,     meta    : { layout : 'home',  requiresAuth : true, title : 'Quizzes'}},
    {path: 'quizzes/start', name: 'QuizStart', component: QuizStart, meta  : { layout : 'home',  requiresAuth : true, title : 'QuizStart'}},
    {path: 'results',   name: 'Results',   component: Results,     meta    : { layout : 'home',  requiresAuth : true, title : 'Results'}},
    {path: 'help',      name: 'Help',      component: Help,        meta    : { layout : 'home',  requiresAuth : true, title : 'Help'}},
]

export default routes;